module.exports = __webpack_public_path__ + "img/lg_ring_g_s_0_null@2x.9f47e4aa.png";